import PlanilhaControleCreditos from '../icms_exclusao/tabela-icms'
import { RelatorioCompensacao } from '../icms_exclusao/relatorio-compensacao'
import ResumoIcmsExclusao from '../icms_exclusao/resumoIcmsExclusao'
import ProductDashboard from '../producto-dashboard'
import { Product } from '../../state/selectProduct'
import { ProdutosStatus } from '@/lib/enums'
import { useFetchApuracaoByIdProduct } from '../../services/useFetchApuracaoByIdProduct'
import { useMemo, useState } from 'react'
import { Loader2 } from 'lucide-react'
import { PageLayout } from '@/layouts'
type previdenciarioProps = {
  cnpj?: string
  product: Product
}
export default function IcmsExclusao({ cnpj, product }: previdenciarioProps) {
  const { data: apuracoes = [], isLoading } = useFetchApuracaoByIdProduct(product?.id ?? '')
  // ID selecionado (default para o primeiro item do array)
  const [selectedId] = useState<string>('')
  const selectedApuracao = useMemo(() => {
    if (!selectedId && apuracoes.length > 0) return apuracoes[0]
    return apuracoes.find((a: { id: string }) => a.id === selectedId) || null
  }, [apuracoes, selectedId])
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-96 z-50">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
      </div>
    )
  }

  return (
    <PageLayout title="Exclusão de ICMS" showSidebarTrigger={false}>
      <ResumoIcmsExclusao rubrica={50} saldo={30} />
      <ProductDashboard
        clientInfo={{
          parceiro: product.parceiro,
          empresa: product.empresa,
          nomeAnalista: product.nomeAnalista,
          status: ProdutosStatus[product.status] ?? product.status
        }}
        cnpj={cnpj ?? ''}
        productId={product.id}
        type="EXCLUSAO_ICMS"
        apuracoes={apuracoes}
        selectedApuracao={selectedApuracao}
      />
      <PlanilhaControleCreditos />
      <RelatorioCompensacao />
    </PageLayout>
  )
}
